export enum EPresenterStep {
  SELECT_PATIENT = 'select-patient',
  ENTER_SYMPTOMS = 'enter-symptoms',
}

export interface IPresenterVisitStore {
  step: EPresenterStep;
  visitId: number;
  setStep: (step: EPresenterStep) => void;
  exitVisit: () => void;
  reset: () => void;
}
